import React from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'

import DOMPurify from '@client/utils/dompurify'
import HtmlModel, { NULL as HtmlModelNULL } from './model'
import inlineStyles from './inlineStyles'

export const Html = ({ model = HtmlModelNULL, serverRender = false }) => {
  return (
    <div
      className={serverRender ? '' : 'code-editor'}
      style={inlineStyles.html}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(model.content) }}
    />
  )
}

Html.propTypes = {
  model: PropTypes.instanceOf(HtmlModel),
  serverRender: PropTypes.bool,
}

export default inject('serverRender')(observer(Html))
